import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Utils from '@shared/utils/utils';
import { DialogBase } from '@routes/dialogs/dialog.base';

@Component({
  selector: 'app-dealer-location',
  templateUrl: './dealer-location.component.html',
  styleUrls: ['./dealer-location.component.scss']
})
export class DealerLocationComponent extends DialogBase implements OnInit {

  title: any;
  id: any;
  bpNo: any;
  buttonLabel: any;
  locationAlias: any;
  addressData = {};
  detailForm: FormGroup;
  error: any;

  get form() {
    return this.detailForm.controls;
  }

  ngOnInit(): void {
    this.setFormControls();
    if (this.locationAlias) {
      this.setEdit(this.locationAlias);
    }
  }

  setFormControls() {
    this.detailForm = this.fb.group({
      bpNo: new FormControl({ value: null, disabled: true }),
      locationAlias: [null, Validators.compose([Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]*$/)])],
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      tel: [null, Validators.compose([Validators.required, Validators.pattern(/\d{3}\d{3}\d{4}/g)])],
      email: [null, Validators.compose([Validators.required, Validators.email])],
      address: null,
    });
  }

  submitForm($event) {
    $event.stopPropagation();
    $event.preventDefault();
    let locationAlias = this.detailForm.getRawValue();
    locationAlias = this.valueRedefinition(locationAlias);
    if (this.detailForm.invalid || this.googlePlacesAutocomplete.validAddress(locationAlias.address)) {
      this.googlePlacesAutocomplete.isAddressValid$.next(true);
      this.detailForm.markAllAsTouched();
      return;
    }
    this.googlePlacesAutocomplete.isAddressValid$.next(false);

    const company = this.authService.getCurrentCompany();
    locationAlias = {
      ...locationAlias,
      company,
      bpNo: this.bpNo,
    }

    if (this.id) {
      this.apiService.dealer.updateLocationAlias(this.bpNo, this.id, locationAlias)
        .subscribe(res => {
          this.onClose.next(res);
          this.bsModalRef.hide();
        }, err => Utils.showError(err));
    } else {
      this.apiService.dealer.createLocationAlias(this.bpNo, locationAlias)
        .subscribe(res => {
          this.onClose.next(res);
          this.bsModalRef.hide();
        }, err => Utils.showError(err));
    }
  }

  valueRedefinition(value) {
    value = {
      ...value, address: {
        address1: (document.getElementById('edit_route') as HTMLInputElement).value,
        address2: (document.getElementById('edit_address2') as HTMLInputElement).value,
        city: (document.getElementById('edit_locality') as HTMLInputElement).value,
        state: (document.getElementById('edit_administrative_area_level_1') as HTMLInputElement).value,
        zipcode: (document.getElementById('edit_postal_code') as HTMLInputElement).value,
        country: (document.getElementById('edit_country') as HTMLInputElement).value,
      }
    };
    return value;
  }

  private setEdit(detailInfo) {
    const form = this.detailForm.controls;
    Object.keys(form).forEach(key => {
      form[key].setValue(detailInfo[key]);
      if (key === 'address') {
        this.addressData = {
          address: detailInfo[key]
        };
      }
    });
  }

}
